import axios from 'axios';
import { http } from '../helpers/axiosHelper';

export default class TeamsService {
   async patchText(textId: Number, body: any, cancelToken: any) {
      return await http
         .patch(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/text/' + textId, body, { cancelToken: cancelToken })
         .then((response) => {
            if (response.status && response.data) {
               return response.data;
            } else {
               throw Error(`Kon tekst niet opslaan`);
            }
         })
         .catch((error) => {
            if (axios.isCancel(error)) return;
            throw Error(`Kon tekst niet opslaan`);
         });
   }

   async postText(body: any, cancelToken: any) {
      return await http
         .post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/text', body, { cancelToken: cancelToken })
         .then((response) => {
            if (response.status && response.data) {
               return response.data;
            } else {
               throw Error(`Kon tekst niet opslaan`);
            }
         })
         .catch((error) => {
            if (axios.isCancel(error)) return;
            throw Error(`Kon tekst niet opslaan`);
         });
   }

   async delete(id: [Number | String]) {
      await http.delete(`${import.meta.env.VITE_APP_API_BASE_URL_DATA}/text/${id}`);
   }
}
